import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

const TransactionHistory = () => {
  const [type, setType] = useState("Deposit");
  const [time, setTime] = useState("Past 30 days");
  const [coin, setCoin] = useState("All");
  const [status, setStatus] = useState("All");
  const [txid, setTxid] = useState("");

  const resetFilters = () => {
    setType("Deposit");
    setTime("Past 30 days");
    setCoin("All");
    setStatus("All");
    setTxid("");
  };

  return (
    <div className="p-6">
      {/* Tabs */}
      <div className="flex space-x-6 border-b text-sm font-medium">
        {["Crypto", "Transfer", "Distribution", "Small Amount Exchange", "Loan", "Funding Wallet", "Referral"].map((tab) => (
          <button
            key={tab}
            className={`pb-2 ${
              tab === "Crypto" ? "text-yellow-500 border-b-2 border-yellow-500" : "text-gray-600"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div className="flex flex-wrap items-center gap-3 mt-4 text-sm">
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="border rounded px-3 py-2"
        >
          <option>Deposit</option>
          <option>Withdraw</option>
        </select>

        <select
          value={time}
          onChange={(e) => setTime(e.target.value)}
          className="border rounded px-3 py-2"
        >
          <option>Past 7 days</option>
          <option>Past 30 days</option>
          <option>Past 90 days</option>
        </select>

        <select
          value={coin}
          onChange={(e) => setCoin(e.target.value)}
          className="border rounded px-3 py-2"
        >
          <option>All</option>
          <option>BTC</option>
          <option>ETH</option>
          <option>USDT</option>
        </select>

        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="border rounded px-3 py-2"
        >
          <option>All</option>
          <option>Completed</option>
          <option>Pending</option>
          <option>Failed</option>
        </select>

        <div className="flex items-center border rounded px-3 py-2">
          <FaSearch className="text-gray-400 mr-2" />
          <input
            type="text"
            placeholder="Enter TxID"
            value={txid}
            onChange={(e) => setTxid(e.target.value)}
            className="outline-none w-32"
          />
        </div>

        <button onClick={resetFilters} className="text-gray-700 font-medium hover:text-yellow-500">
          Reset
        </button>
      </div>

      {/* Help link */}
      <div className="mt-3">
        <a href="#" className="text-yellow-600 text-sm underline">
          Deposit hasn’t arrived?
        </a>
      </div>

      {/* Table */}
      <div className="mt-6 border-t">
        <table className="w-full text-sm text-gray-700">
          <thead>
            <tr className="text-gray-500 text-left">
              <th className="py-2">Time</th>
              <th className="py-2">Type</th>
              <th className="py-2">Deposit wallet</th>
              <th className="py-2">Coin</th>
              <th className="py-2">Amount</th>
              <th className="py-2">Destination</th>
              <th className="py-2">TxID</th>
              <th className="py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={8} className="text-center py-10 text-gray-400">
                <div className="flex flex-col items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-10 w-10 text-gray-300"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405M19 13V7a2 2 0 00-2-2h-4l-2-2H7a2 2 0 00-2 2v6M3 13h6v6H3v-6z" />
                  </svg>
                  <p className="mt-2">No records</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionHistory;